/** Internal type. DO NOT USE DIRECTLY. */
type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
/** Internal type. DO NOT USE DIRECTLY. */
export type Incremental<T> =
  | T
  | {
      [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never;
    };
import type * as Types from './graphql.schema-types';

import { gql } from 'apollo-angular';
import { Injectable } from '@angular/core';
import * as Apollo from 'apollo-angular';
export * from './graphql.schema-types';
export type FilePricingFragment = {
  isFull: boolean | null;
  size: number | null;
  filePricingId: string | null;
  stepPricingEnabled: boolean | null;
  price: Array<{ code: string | null; price: number | null } | null> | null;
  stepPricing: {
    firstStep: number | null;
    mode: Types.StepPricingMode | null;
    isFirstStepFree: boolean | null;
    lastStepPrice: Array<{
      code: string | null;
      price: number | null;
    } | null> | null;
    steps: Array<{
      step: number | null;
      price: Array<{ code: string | null; price: number | null } | null> | null;
    } | null> | null;
  } | null;
  printsIncluded: Array<{
    count: number | null;
    printFormatId: string | null;
    printPaperId: string | null;
  } | null> | null;
};

export type PrivateSessionGroupFragment = {
  order: number | null;
  privateSessionGroupId: string | null;
  privateSessionId: string | null;
  customProductsConfig: boolean | null;
  productsSort: Array<string | null> | null;
  sellProducts: boolean | null;
  excludedProducts: Array<string | null> | null;
  customFilesPricing: boolean | null;
  customPrintsPricing: boolean | null;
  individualSellSettings: boolean | null;
  deleted: boolean | null;
  sellPrints: boolean | null;
  sellFiles: boolean | null;
  photoGroupId: string | null;
  addToFirstPrintPrice: boolean | null;
  addPriceToEveryFileInProduct: boolean | null;
  useFilePricingToCalculatePriceToAddToEveryFileInProduct: boolean | null;
  skipAddToEveryFileInProductIfFileBought: boolean | null;
  addEveryFileToBasketIfNotAlreadyBought: boolean | null;
  addPrintFileToBasketIfNotAlreadyBought: boolean | null;
  skipAddToFirstPrintIfFileBought: boolean | null;
  name: Array<{ language: string | null; text: string | null } | null> | null;
  images: Array<{
    height: number | null;
    photoGroupHasPhotoId: string;
    photoId: string | null;
    width: number | null;
    photoGroupId: string | null;
    originalName: string | null;
  } | null> | null;
  priceToAddToEveryFileInProduct: Array<{
    code: string | null;
    price: number | null;
  } | null> | null;
  priceToAddToFirstPrint: Array<{
    code: string | null;
    price: number | null;
  } | null> | null;
  filePricing: Array<{
    isFull: boolean | null;
    size: number | null;
    filePricingId: string | null;
    stepPricingEnabled: boolean | null;
    price: Array<{ code: string | null; price: number | null } | null> | null;
    stepPricing: {
      firstStep: number | null;
      mode: Types.StepPricingMode | null;
      isFirstStepFree: boolean | null;
      lastStepPrice: Array<{
        code: string | null;
        price: number | null;
      } | null> | null;
      steps: Array<{
        step: number | null;
        price: Array<{
          code: string | null;
          price: number | null;
        } | null> | null;
      } | null> | null;
    } | null;
    printsIncluded: Array<{
      count: number | null;
      printFormatId: string | null;
      printPaperId: string | null;
    } | null> | null;
  } | null> | null;
  printsPricing: {
    printsPricingListForDisplayId: string | null;
    list: Array<{
      printFormatId: string | null;
      printPaperId: string | null;
      stepPricingEnabled: boolean | null;
      price: Array<{ code: string | null; price: number | null } | null> | null;
      stepPricing: {
        firstStep: number | null;
        isFirstStepFree: boolean | null;
        mode: Types.StepPricingMode | null;
        lastStepPrice: Array<{
          code: string | null;
          price: number | null;
        } | null> | null;
        steps: Array<{
          step: number | null;
          price: Array<{
            code: string | null;
            price: number | null;
          } | null> | null;
        } | null> | null;
      } | null;
    } | null> | null;
  } | null;
};

export type PrivateSessionForDisplayQueryVariables = Exact<{
  privateSessionId: string;
  sessionId: string;
  deviceDetails?: string | null | undefined;
  resolution?: string | null | undefined;
}>;

export type PrivateSessionForDisplayQuery = {
  getPrivateSessionForDisplay: {
    privateSessionId: string | null;
    organizationId: string | null;
    squareLogo: string | null;
    horizontalLogo: string | null;
    sellFiles: boolean | null;
    sellPrints: boolean | null;
    sellPackages: boolean | null;
    sellProducts: boolean | null;
    digitalOrderForcePhone: boolean | null;
    freeThumbSize: number | null;
    enableFreeThumb: boolean | null;
    usePromoCodes: boolean | null;
    autoSellEnabled: boolean | null;
    salesMode: Types.PrivateSessionSalesModeForDisplay | null;
    created: number | null;
    productsSort: Array<string | null> | null;
    skipAddToFirstPrintIfFileBought: boolean | null;
    addToFirstPrintPrice: boolean | null;
    freePackageId: string | null;
    addPriceToEveryFileInProduct: boolean | null;
    skipAddToEveryFileInProductIfFileBought: boolean | null;
    addEveryFileToBasketIfNotAlreadyBought: boolean | null;
    addPrintFileToBasketIfNotAlreadyBought: boolean | null;
    useFilePricingToCalculatePriceToAddToEveryFileInProduct: boolean | null;
    useFilePricingToCalculatePriceToAddToEveryFileInPrint: boolean | null;
    retouchLevelsEnabled: boolean | null;
    excludedProducts: Array<string | null> | null;
    showFileNames: boolean | null;
    seenRecommendationComments: Array<string | null> | null;
    photographerAvatar: string | null;
    lookBookEnabled: boolean | null;
    skipFavoriteInFileMode: boolean | null;
    visualPersonalization: string | null;
    allowComments: boolean | null;
    clientPermissionsConfig: string | null;
    name: Array<{ language: string | null; text: string | null } | null> | null;
    autoSellConfig: {
      organizationId: string | null;
      verifyOrders: boolean | null;
      verificationMode: Types.AutoSellOrderVerificationMode | null;
    } | null;
    photoSuggestions: Array<{
      photoId: string | null;
      comment: Array<{
        language: string | null;
        text: string | null;
      } | null> | null;
    } | null> | null;
    printsPricing: {
      printsPricingListForDisplayId: string | null;
      list: Array<{
        printFormatId: string | null;
        printPaperId: string | null;
        stepPricingEnabled: boolean | null;
        price: Array<{
          code: string | null;
          price: number | null;
        } | null> | null;
        stepPricing: {
          firstStep: number | null;
          isFirstStepFree: boolean | null;
          mode: Types.StepPricingMode | null;
          lastStepPrice: Array<{
            code: string | null;
            price: number | null;
          } | null> | null;
          steps: Array<{
            step: number | null;
            price: Array<{
              code: string | null;
              price: number | null;
            } | null> | null;
          } | null> | null;
        } | null;
      } | null> | null;
    } | null;
    filePricing: Array<{
      isFull: boolean | null;
      size: number | null;
      filePricingId: string | null;
      stepPricingEnabled: boolean | null;
      price: Array<{ code: string | null; price: number | null } | null> | null;
      stepPricing: {
        firstStep: number | null;
        mode: Types.StepPricingMode | null;
        isFirstStepFree: boolean | null;
        lastStepPrice: Array<{
          code: string | null;
          price: number | null;
        } | null> | null;
        steps: Array<{
          step: number | null;
          price: Array<{
            code: string | null;
            price: number | null;
          } | null> | null;
        } | null> | null;
      } | null;
      printsIncluded: Array<{
        count: number | null;
        printFormatId: string | null;
        printPaperId: string | null;
      } | null> | null;
    } | null> | null;
    availableProducts: Array<{
      availableOnOccasion: Array<Types.SessionOccasion | null> | null;
      composedImages: string | null;
      config: string | null;
      configurationImages: string | null;
      deliveryTime: number | null;
      hasWizard: boolean | null;
      imagesRequired: boolean | null;
      name: string | null;
      productId: string | null;
      showDeliveryTime: boolean | null;
      status: boolean | null;
      type: Types.ProductType | null;
      sortOrder: number | null;
      description: Array<{
        language: string | null;
        text: string | null;
      } | null> | null;
      price: Array<{ code: string | null; price: number | null } | null> | null;
      requiredImages: { max: number | null; min: number | null } | null;
    } | null> | null;
    deliveryMethods: Array<{
      addressRequired: boolean | null;
      currencyId: string | null;
      deliveryMethodId: string | null;
      freeFrom: number | null;
      label: string | null;
      mightBeFree: boolean | null;
      phoneRequired: boolean | null;
      pickupAddress: string | null;
      pickupNote: string | null;
      preOrderNote: string | null;
      price: number | null;
      status: boolean | null;
      type: Types.DeliveryType | null;
      countryId: string | null;
      isAutoSell: boolean | null;
      additionalFields: Array<{ name: string | null } | null> | null;
    } | null> | null;
    packages: Array<{
      name: string | null;
      icon: string | null;
      productPackageId: string | null;
      allowMultiple: boolean | null;
      printAndFileConfig: Array<{
        printAndFileConfigId: string | null;
        mode: Types.FilesAndPrintsPackageType | null;
        groups: Array<string | null> | null;
        forcedImage: {
          photoGroupId: string | null;
          photoId: string | null;
        } | null;
        filesConfig: Array<{
          isFull: boolean | null;
          count: number | null;
          size: number | null;
        } | null> | null;
        printsCount: Array<{
          count: number | null;
          printFormatId: string | null;
          printPaperId: string | null;
        } | null> | null;
      } | null> | null;
      price: Array<{ code: string | null; price: number | null } | null> | null;
      productConfig: Array<{
        config: string | null;
        productId: string | null;
        productInPackageId: string | null;
        qty: number | null;
        mode: Types.ProductMode | null;
        icon: string | null;
        customName: Array<{
          language: string | null;
          text: string | null;
        } | null> | null;
      } | null> | null;
    } | null> | null;
    priceToAddToFirstPrint: Array<{
      code: string | null;
      price: number | null;
    } | null> | null;
    cover: {
      file: string | null;
      x: number | null;
      y: number | null;
      coverSetupId: string | null;
      size: { h: number | null; w: number | null } | null;
    } | null;
    groups: Array<{
      order: number | null;
      privateSessionGroupId: string | null;
      privateSessionId: string | null;
      customProductsConfig: boolean | null;
      productsSort: Array<string | null> | null;
      sellProducts: boolean | null;
      excludedProducts: Array<string | null> | null;
      customFilesPricing: boolean | null;
      customPrintsPricing: boolean | null;
      individualSellSettings: boolean | null;
      deleted: boolean | null;
      sellPrints: boolean | null;
      sellFiles: boolean | null;
      photoGroupId: string | null;
      addToFirstPrintPrice: boolean | null;
      addPriceToEveryFileInProduct: boolean | null;
      useFilePricingToCalculatePriceToAddToEveryFileInProduct: boolean | null;
      skipAddToEveryFileInProductIfFileBought: boolean | null;
      addEveryFileToBasketIfNotAlreadyBought: boolean | null;
      addPrintFileToBasketIfNotAlreadyBought: boolean | null;
      skipAddToFirstPrintIfFileBought: boolean | null;
      name: Array<{
        language: string | null;
        text: string | null;
      } | null> | null;
      images: Array<{
        height: number | null;
        photoGroupHasPhotoId: string;
        photoId: string | null;
        width: number | null;
        photoGroupId: string | null;
        originalName: string | null;
      } | null> | null;
      priceToAddToEveryFileInProduct: Array<{
        code: string | null;
        price: number | null;
      } | null> | null;
      priceToAddToFirstPrint: Array<{
        code: string | null;
        price: number | null;
      } | null> | null;
      filePricing: Array<{
        isFull: boolean | null;
        size: number | null;
        filePricingId: string | null;
        stepPricingEnabled: boolean | null;
        price: Array<{
          code: string | null;
          price: number | null;
        } | null> | null;
        stepPricing: {
          firstStep: number | null;
          mode: Types.StepPricingMode | null;
          isFirstStepFree: boolean | null;
          lastStepPrice: Array<{
            code: string | null;
            price: number | null;
          } | null> | null;
          steps: Array<{
            step: number | null;
            price: Array<{
              code: string | null;
              price: number | null;
            } | null> | null;
          } | null> | null;
        } | null;
        printsIncluded: Array<{
          count: number | null;
          printFormatId: string | null;
          printPaperId: string | null;
        } | null> | null;
      } | null> | null;
      printsPricing: {
        printsPricingListForDisplayId: string | null;
        list: Array<{
          printFormatId: string | null;
          printPaperId: string | null;
          stepPricingEnabled: boolean | null;
          price: Array<{
            code: string | null;
            price: number | null;
          } | null> | null;
          stepPricing: {
            firstStep: number | null;
            isFirstStepFree: boolean | null;
            mode: Types.StepPricingMode | null;
            lastStepPrice: Array<{
              code: string | null;
              price: number | null;
            } | null> | null;
            steps: Array<{
              step: number | null;
              price: Array<{
                code: string | null;
                price: number | null;
              } | null> | null;
            } | null> | null;
          } | null;
        } | null> | null;
      } | null;
    } | null> | null;
    priceToAddToEveryFileInProduct: Array<{
      code: string | null;
      price: number | null;
    } | null> | null;
    retouchLevels: Array<{
      retouchLevelId: string | null;
      label: Array<{
        language: string | null;
        text: string | null;
      } | null> | null;
      price: Array<{ code: string | null; price: number | null } | null> | null;
    } | null> | null;
    client: {
      firstName: string | null;
      lastName: string | null;
      phone: string | null;
      email: string | null;
      privateSessionClientId: string | null;
    } | null;
    messages: Array<{
      context: Types.PrivateSessionMessageContext | null;
      message: Array<{
        language: string | null;
        text: string | null;
      } | null> | null;
    } | null> | null;
    settlements: {
      basicSessionPrice: {
        alreadyPaid: boolean | null;
        isSet: boolean | null;
        price: Array<{
          price: number | null;
          code: string | null;
        } | null> | null;
      } | null;
      requiredPrePayment: {
        alreadyPaid: boolean | null;
        isSet: boolean | null;
        prePaidOption: Types.PrepaidOptions | null;
        price: Array<{
          price: number | null;
          code: string | null;
        } | null> | null;
      } | null;
    } | null;
    lookBookConfig: {
      sellWallDecor: boolean | null;
      sellTambour: boolean | null;
      sellTriplex: boolean | null;
      sellPrintFrames: boolean | null;
      addEveryFileToBasketIfNotAlreadyBought: boolean | null;
      addPriceToEveryFileInProduct: boolean | null;
      skipAddToEveryFileInProductIfFileBought: boolean | null;
      useFilePricingToCalculatePriceToAddToEveryFileInProduct: boolean | null;
      wallDecorConfig: {
        rounding: Types.LookBookPriceRounding | null;
        labId: string | null;
        preConfig: string | null;
        disablePersonalizationOnSinglePhoto: boolean | null;
      } | null;
      tambourConfig: {
        rounding: Types.LookBookPriceRounding | null;
        labId: string | null;
        preConfig: string | null;
        disablePersonalizationOnSinglePhoto: boolean | null;
      } | null;
      triplexConfig: {
        limitMaterials: boolean | null;
        availableMaterials: Array<string | null> | null;
        rounding: Types.LookBookPriceRounding | null;
        labId: string | null;
      } | null;
      printFramesConfig: {
        availableColors: Array<string | null> | null;
        limitColors: boolean | null;
        rounding: Types.LookBookPriceRounding | null;
      } | null;
      priceToAddToEveryFileInProduct: Array<{
        code: string | null;
        price: number | null;
      } | null> | null;
    } | null;
    frame: {
      productId: string | null;
      config: string | null;
      price: Array<{ code: string | null; price: number | null } | null> | null;
    } | null;
  } | null;
};

export type LookBookPreviewDetailsFragment = {
  fileName: string | null;
  wallDecorSceneId: string | null;
  accessToken: string | null;
  wallDecorRenderPreviewConfigId: string | null;
  color: string | null;
  images: Array<{
    photoGroupId: string | null;
    photoId: string | null;
    wallDecorPieceId: string | null;
    isFlip: boolean | null;
    crop: {
      h: number | null;
      w: number | null;
      x: number | null;
      y: number | null;
    } | null;
  } | null> | null;
};

export type TriplexPreviewDetailsFragment = {
  fileName: string | null;
  accessToken: string | null;
  triplexRenderPreviewConfigId: string | null;
  value: string | null;
  images: Array<{
    photoGroupId: string | null;
    photoId: string | null;
    wallDecorPieceId: string | null;
    isFlip: boolean | null;
    crop: {
      h: number | null;
      w: number | null;
      x: number | null;
      y: number | null;
    } | null;
  } | null> | null;
};

export type GetPrivateSessionUserBasketQueryVariables = Exact<{
  privateSessionId: string;
}>;

export type GetPrivateSessionUserBasketQuery = {
  getPrivateSessionUserBasket: {
    favorites: Array<string | null> | null;
    stateBasketId: string | null;
    pickedDeliveryMethodId: string | null;
    deliveryDetails: string | null;
    files: Array<{
      filePricingId: string | null;
      isFull: boolean | null;
      photoId: string | null;
      retouchLevelId: string | null;
      size: number | null;
      timeAddedToShoppingCart: number | null;
      togetherWithPrint: boolean | null;
      togetherWithProduct: boolean | null;
    } | null> | null;
    printFramesInBasket: Array<{
      printFrameId: string | null;
      photoId: string | null;
      count: number | null;
      printFormatId: string | null;
      ratio: number | null;
      value: string | null;
      price: Array<{ code: string | null; price: number | null } | null> | null;
    } | null> | null;
    prints: Array<{
      photoId: string | null;
      count: number | null;
      printFormatId: string | null;
      printPaperId: string | null;
      printId: string | null;
      timeAddedToShoppingCart: number | null;
      togetherWithFile: boolean | null;
    } | null> | null;
    products: Array<{
      timeAddedToShoppingCart: number | null;
      configuration: string | null;
      nameClientProduct: string | null;
      photoIdList: Array<string | null> | null;
      productId: string | null;
      quantity: number | null;
      redBackground: boolean | null;
      selectedProductId: string | null;
      finished: {
        allImages: boolean | null;
        allOptions: boolean | null;
      } | null;
    } | null> | null;
    lookBookProductsInBasket: Array<{
      config: string | null;
      lookBookProductId: string | null;
      redBackground: boolean | null;
      finished: boolean | null;
      lookBookProductConfigId: string | null;
      productsInPlay: Array<string | null> | null;
      firstAddedFile: boolean | null;
      hasPersonalization: boolean | null;
      nameClientProduct: string | null;
      personalizationConfig: string | null;
      photoIdList: Array<string | null> | null;
      quantity: number | null;
      thumb: string | null;
      valueMap: string | null;
      accessToken: string | null;
      timeAddedToShoppingCart: number | null;
      countPhotos: { min: number | null; max: number | null } | null;
      name: Array<{
        text: string | null;
        language: string | null;
      } | null> | null;
      price: Array<{ price: number | null; code: string | null } | null> | null;
      imageMap: Array<{
        isFlip: boolean | null;
        photoGroupId: string | null;
        photoId: string | null;
        wallDecorPieceId: string | null;
        crop: {
          y: number | null;
          x: number | null;
          w: number | null;
          h: number | null;
        } | null;
      } | null> | null;
    } | null> | null;
    lookBookWallDecorPreviewRender: {
      fileName: string | null;
      wallDecorSceneId: string | null;
      accessToken: string | null;
      wallDecorRenderPreviewConfigId: string | null;
      color: string | null;
      images: Array<{
        photoGroupId: string | null;
        photoId: string | null;
        wallDecorPieceId: string | null;
        isFlip: boolean | null;
        crop: {
          h: number | null;
          w: number | null;
          x: number | null;
          y: number | null;
        } | null;
      } | null> | null;
    } | null;
    lookBookTambourPreviewRender: {
      fileName: string | null;
      wallDecorSceneId: string | null;
      accessToken: string | null;
      wallDecorRenderPreviewConfigId: string | null;
      color: string | null;
      images: Array<{
        photoGroupId: string | null;
        photoId: string | null;
        wallDecorPieceId: string | null;
        isFlip: boolean | null;
        crop: {
          h: number | null;
          w: number | null;
          x: number | null;
          y: number | null;
        } | null;
      } | null> | null;
    } | null;
    triplexPreviewRender: {
      fileName: string | null;
      accessToken: string | null;
      triplexRenderPreviewConfigId: string | null;
      value: string | null;
      images: Array<{
        photoGroupId: string | null;
        photoId: string | null;
        wallDecorPieceId: string | null;
        isFlip: boolean | null;
        crop: {
          h: number | null;
          w: number | null;
          x: number | null;
          y: number | null;
        } | null;
      } | null> | null;
    } | null;
    photoComments: Array<{
      state: Types.PhotoCommentState;
      photoCommentId: string;
      photoId: string | null;
      position: { x: number; y: number } | null;
      messages: Array<{
        posted: number;
        comment: string;
        author: number;
      } | null>;
    } | null> | null;
  } | null;
};

export type GetPrivateSessionUserOldBasketQueryVariables = Exact<{
  privateSessionId: string;
}>;

export type GetPrivateSessionUserOldBasketQuery = {
  getPrivateSessionUserOldBasket: {
    files: Array<{
      filePricingId: string | null;
      photoId: string | null;
      togetherWithPrint: boolean | null;
      togetherWithProduct: boolean | null;
    } | null> | null;
    prints: Array<{
      photoId: string | null;
      count: number | null;
      printFormatId: string | null;
      printPaperId: string | null;
      togetherWithFile: boolean | null;
    } | null> | null;
  } | null;
};

export type PlaceOrderMutationVariables = Exact<{
  orderDetails?: Types.NewShoppingCartOrderInput | null | undefined;
}>;

export type PlaceOrderMutation = {
  placeShoppingCartOrder: {
    orderId: string | null;
    orderNumber: number | null;
    placed: number | null;
    hash: string | null;
    sourceInactive: boolean | null;
    authToken: string | null;
    status: Array<{
      done: boolean | null;
      statusId: string | null;
      order: number | null;
      label: { language: string | null; text: string | null } | null;
    } | null> | null;
  } | null;
};

export type ChangeFavPhotoStatusMutationVariables = Exact<{
  privateSessionId: string;
  isLiked: boolean;
  photoId: string;
  sessionId: string;
}>;

export type ChangeFavPhotoStatusMutation = {
  privateSessionChangeFavPhotoStatus: { status: boolean | null } | null;
};

export type PrivateSessionPhotoAddedToFilesMutationVariables = Exact<{
  photoIds: Array<string | null | undefined> | string;
  privateSessionId: string;
  isFull: boolean;
  size: number;
  sessionId: string;
  filePricingId: string;
  retouchLevel: string;
  retouchLevelId: string;
  state: Array<Types.FileState | null | undefined> | Types.FileState;
}>;

export type PrivateSessionPhotoAddedToFilesMutation = {
  privateSessionPhotosAddedToFiles: { status: boolean | null } | null;
};

export type PrivateSessionPhotoRemovedFromFilesMutationVariables = Exact<{
  privateSessionId: string;
  sessionId: string;
  photoIds: Array<string | null | undefined> | string;
}>;

export type PrivateSessionPhotoRemovedFromFilesMutation = {
  privateSessionPhotosRemovedFromFiles: { status: boolean | null } | null;
};

export type PrivateSessionPhotosRemovedFromPrintsMutationVariables = Exact<{
  printIds: Array<string | null | undefined> | string;
  privateSessionId: string;
  sessionId: string;
}>;

export type PrivateSessionPhotosRemovedFromPrintsMutation = {
  privateSessionPhotosRemovedFromPrints: { status: boolean | null } | null;
};

export type PrivateSessionPhotosChangedSizeMutationVariables = Exact<{
  sessionId: string;
  privateSessionId: string;
  photoIds: Array<string | null | undefined> | string;
  isFull: boolean;
  size: number;
  filePricingId: string;
}>;

export type PrivateSessionPhotosChangedSizeMutation = {
  privateSessionPhotosChangedSize: { status: boolean | null } | null;
};

export type PrivateSessionPhotosAddedToPrintsMutationVariables = Exact<{
  photoIds: Array<string | null | undefined> | string;
  privateSessionId: string;
  sessionId: string;
  printFormatId: string;
  printPaperId: string;
  state: Array<Types.PrintState | null | undefined> | Types.PrintState;
  togetherWithFile?: boolean | null | undefined;
  count: number;
}>;

export type PrivateSessionPhotosAddedToPrintsMutation = {
  privateSessionPhotosAddedToPrints: { status: boolean | null } | null;
};

export type PrivateSessionMarkRecommendationCommentAsSeenMutationVariables =
  Exact<{
    privateSessionId: string;
    photoId: string;
    sessionId: string;
    alreadySeen: boolean;
    content:
      Array<Types.CustomLabelInput | null | undefined> | Types.CustomLabelInput;
  }>;

export type PrivateSessionMarkRecommendationCommentAsSeenMutation = {
  privateSessionMarkRecommendationCommentAsSeen: {
    status: boolean | null;
  } | null;
};

export type PrivateSessionPhotosChangedRetouchLevelMutationVariables = Exact<{
  photoIds: Array<string | null | undefined> | string;
  privateSessionId: string;
  retouchLevel: string;
  retouchLevelId: string;
  sessionId: string;
}>;

export type PrivateSessionPhotosChangedRetouchLevelMutation = {
  privateSessionPhotosChangedRetouchLevel: { status: boolean | null } | null;
};

export type PrivateSessionAddedProductToBasketMutationVariables = Exact<{
  privateSessionId: string;
  sessionId: string;
  configuration: string;
  finished: Types.FinishedProductMutation;
  nameClientProduct: string;
  photoIdList: Array<string | null | undefined> | string;
  productId: string;
  quantity: number;
  redBackground: boolean;
  firstAddedFile: boolean;
  selectedProductId: string;
}>;

export type PrivateSessionAddedProductToBasketMutation = {
  privateSessionAddedProductToBasket: { status: boolean | null } | null;
};

export type PrivateSessionChangeQuantityProductMutationVariables = Exact<{
  privateSessionId: string;
  sessionId: string;
  selectedProductId?: string | null | undefined;
  quantity?: number | null | undefined;
}>;

export type PrivateSessionChangeQuantityProductMutation = {
  privateSessionChangeQuantityProduct: { status: boolean | null } | null;
};

export type PrivateSessionChangePhotosInProductMutationVariables = Exact<{
  privateSessionId: string;
  sessionId: string;
  selectedProductId?: string | null | undefined;
  addedPhotoIdList?:
    Array<string | null | undefined> | string | null | undefined;
  removedPhotoIdList?:
    Array<string | null | undefined> | string | null | undefined;
  finishedAllImages?: boolean | null | undefined;
  redBackground?: boolean | null | undefined;
}>;

export type PrivateSessionChangePhotosInProductMutation = {
  privateSessionChangePhotosInProduct: { status: boolean | null } | null;
};

export type PrivateSessionChangeConfigInProductMutationVariables = Exact<{
  privateSessionId: string;
  sessionId: string;
  selectedProductId?: string | null | undefined;
  configuration?: string | null | undefined;
  finishedAllOptions?: boolean | null | undefined;
  redBackground?: boolean | null | undefined;
}>;

export type PrivateSessionChangeConfigInProductMutation = {
  privateSessionChangeConfigInProduct: { status: boolean | null } | null;
};

export type PrivateSessionRemovedProductFromBasketMutationVariables = Exact<{
  privateSessionId: string;
  sessionId: string;
  selectedProductId?: string | null | undefined;
}>;

export type PrivateSessionRemovedProductFromBasketMutation = {
  privateSessionRemovedProductFromBasket: { status: boolean | null } | null;
};

export type WatchForPrivateSessionActionsSubscriptionVariables = Exact<{
  privateSessionId: string;
  sessionId: string;
}>;

export type WatchForPrivateSessionActionsSubscription = {
  watchForPrivateSessionActions: {
    sessionId: string | null;
    action: string | null;
    payload: string | null;
  } | null;
};

export type SharePrivateSessionActionMutationVariables = Exact<{
  action: string;
  payload: string;
  sessionId: string;
  privateSessionId: string;
}>;

export type SharePrivateSessionActionMutation = {
  sharePrivateSessionAction: { status: boolean | null } | null;
};

export type TriplexProductFragment = {
  availableOnOccasion: Array<Types.SessionOccasion | null> | null;
  composedImages: string | null;
  config: string | null;
  configurationImages: string | null;
  deliveryTime: number | null;
  hasWizard: boolean | null;
  imagesRequired: boolean | null;
  name: string | null;
  productId: string | null;
  showDeliveryTime: boolean | null;
  status: boolean | null;
  type: Types.ProductType | null;
  sortOrder: number | null;
  organizationId: string | null;
  description: Array<{
    language: string | null;
    text: string | null;
  } | null> | null;
  price: Array<{ code: string | null; price: number | null } | null> | null;
  requiredImages: { max: number | null; min: number | null } | null;
};

export type GetLookBookTriplexDetailsForPrivateSessionQueryVariables = Exact<{
  privateSessionId: string;
}>;

export type GetLookBookTriplexDetailsForPrivateSessionQuery = {
  getTriplexLookBookConfigForPrivateSession: {
    labsInPlay: Array<string | null> | null;
    labProducts: Array<{
      availableOnOccasion: Array<Types.SessionOccasion | null> | null;
      composedImages: string | null;
      config: string | null;
      configurationImages: string | null;
      deliveryTime: number | null;
      hasWizard: boolean | null;
      imagesRequired: boolean | null;
      name: string | null;
      productId: string | null;
      showDeliveryTime: boolean | null;
      status: boolean | null;
      type: Types.ProductType | null;
      sortOrder: number | null;
      organizationId: string | null;
      description: Array<{
        language: string | null;
        text: string | null;
      } | null> | null;
      price: Array<{ code: string | null; price: number | null } | null> | null;
      requiredImages: { max: number | null; min: number | null } | null;
    } | null> | null;
    zalamoStandaloneTriplex: {
      availableOnOccasion: Array<Types.SessionOccasion | null> | null;
      composedImages: string | null;
      config: string | null;
      configurationImages: string | null;
      deliveryTime: number | null;
      hasWizard: boolean | null;
      imagesRequired: boolean | null;
      name: string | null;
      productId: string | null;
      showDeliveryTime: boolean | null;
      status: boolean | null;
      type: Types.ProductType | null;
      sortOrder: number | null;
      organizationId: string | null;
      description: Array<{
        language: string | null;
        text: string | null;
      } | null> | null;
      price: Array<{ code: string | null; price: number | null } | null> | null;
      requiredImages: { max: number | null; min: number | null } | null;
    } | null;
  } | null;
};

export type UpdateWallDecorPreviewUpdateMutationVariables = Exact<{
  privateSessionId: string;
  update?: Types.WallDecorRenderPreviewConfigInput | null | undefined;
}>;

export type UpdateWallDecorPreviewUpdateMutation = {
  updatePrivateSessionWallDecorPreview: {
    fileName: string | null;
    wallDecorSceneId: string | null;
    accessToken: string | null;
    wallDecorRenderPreviewConfigId: string | null;
    color: string | null;
    images: Array<{
      photoGroupId: string | null;
      photoId: string | null;
      wallDecorPieceId: string | null;
      isFlip: boolean | null;
      crop: {
        h: number | null;
        w: number | null;
        x: number | null;
        y: number | null;
      } | null;
    } | null> | null;
  } | null;
};

export type UpdateTambourPreviewUpdateMutationVariables = Exact<{
  privateSessionId: string;
  update?: Types.WallDecorRenderPreviewConfigInput | null | undefined;
}>;

export type UpdateTambourPreviewUpdateMutation = {
  updatePrivateSessionTambourPreview: {
    fileName: string | null;
    wallDecorSceneId: string | null;
    accessToken: string | null;
    wallDecorRenderPreviewConfigId: string | null;
    color: string | null;
    images: Array<{
      photoGroupId: string | null;
      photoId: string | null;
      wallDecorPieceId: string | null;
      isFlip: boolean | null;
      crop: {
        h: number | null;
        w: number | null;
        x: number | null;
        y: number | null;
      } | null;
    } | null> | null;
  } | null;
};

export type UpdateTriplexPreviewUpdateMutationVariables = Exact<{
  privateSessionId: string;
  update?: Types.TriplexRenderPreviewConfigInput | null | undefined;
}>;

export type UpdateTriplexPreviewUpdateMutation = {
  updatePrivateSessionTriplexPreview: {
    fileName: string | null;
    accessToken: string | null;
    triplexRenderPreviewConfigId: string | null;
    value: string | null;
    images: Array<{
      photoGroupId: string | null;
      photoId: string | null;
      wallDecorPieceId: string | null;
      isFlip: boolean | null;
      crop: {
        h: number | null;
        w: number | null;
        x: number | null;
        y: number | null;
      } | null;
    } | null> | null;
  } | null;
};

export type PrivateSessionLookBookProductAddedToBasketMutationVariables =
  Exact<{
    privateSessionId: string;
    product?: Types.LookBookInBasketInput | null | undefined;
  }>;

export type PrivateSessionLookBookProductAddedToBasketMutation = {
  privateSessionLookBookProductAddedToBasket: { status: boolean | null } | null;
};

export type PrivateSessionLookBookProductDeletedMutationVariables = Exact<{
  privateSessionId: string;
  lookBookProductConfigId: string;
}>;

export type PrivateSessionLookBookProductDeletedMutation = {
  privateSessionLookBookProductDeleted: { status: boolean | null } | null;
};

export type PrivateSessionLookBookProductCountChangedMutationVariables = Exact<{
  privateSessionId: string;
  lookBookProductConfigId: string;
  quantity: number;
}>;

export type PrivateSessionLookBookProductCountChangedMutation = {
  privateSessionLookBookProductCountChanged: { status: boolean | null } | null;
};

export type PrivateSessionLookBookProductChangedMutationVariables = Exact<{
  lookBookProductConfigId: string;
  privateSessionId: string;
  update: Types.LookBookInBasketInput;
}>;

export type PrivateSessionLookBookProductChangedMutation = {
  privateSessionLookBookProductChanged: { status: boolean | null } | null;
};

export type AddPhotoCommentToPrivateSessionPhotoMutationVariables = Exact<{
  message: string;
  photoCommentId: string;
  photoId: string;
  privateSessionId: string;
  x: number;
  y: number;
}>;

export type AddPhotoCommentToPrivateSessionPhotoMutation = {
  addPhotoCommentToPrivateSessionPhoto: {
    photoCommentId: string;
    state: Types.PhotoCommentState;
    photoId: string | null;
    messages: Array<{ comment: string; author: number; posted: number } | null>;
    position: { y: number; x: number } | null;
  } | null;
};

export type UpdatePhotoCommentToPrivateSessionPhotoMutationVariables = Exact<{
  message: string;
  photoCommentId: string;
  privateSessionId: string;
}>;

export type UpdatePhotoCommentToPrivateSessionPhotoMutation = {
  updatePhotoCommentToPrivateSessionPhoto: {
    photoCommentId: string;
    state: Types.PhotoCommentState;
    photoId: string | null;
    messages: Array<{ comment: string; author: number; posted: number } | null>;
    position: { y: number; x: number } | null;
  } | null;
};

export type RemovePhotoCommentToPrivateSessionPhotoMutationVariables = Exact<{
  photoCommentId: string;
  privateSessionId: string;
}>;

export type RemovePhotoCommentToPrivateSessionPhotoMutation = {
  removePhotoCommentToPrivateSessionPhoto: { status: boolean | null } | null;
};

export type PrivateSessionPrintFrameAddedToBasketMutationVariables = Exact<{
  privateSessionId: string;
  product?: Types.PrintFrameInBasketInput | null | undefined;
}>;

export type PrivateSessionPrintFrameAddedToBasketMutation = {
  privateSessionPrintFrameAddedToBasket: { status: boolean | null } | null;
};

export type PrivateSessionPrintFrameDeletedMutationVariables = Exact<{
  privateSessionId: string;
  printFrameId: string;
}>;

export type PrivateSessionPrintFrameDeletedMutation = {
  privateSessionPrintFrameDeleted: { status: boolean | null } | null;
};

export type PrivateSessionPrintFrameCountChangedMutationVariables = Exact<{
  privateSessionId: string;
  printFrameId: string;
  quantity: number;
}>;

export type PrivateSessionPrintFrameCountChangedMutation = {
  privateSessionPrintFrameCountChanged: { status: boolean | null } | null;
};

export type PrivateSessionPrintFrameChangedMutationVariables = Exact<{
  privateSessionId: string;
  printFrameId: string;
  update: Types.PrintFrameInBasketInput;
}>;

export type PrivateSessionPrintFrameChangedMutation = {
  privateSessionPrintFrameChanged: { status: boolean | null } | null;
};

export type PrivateSessionSaveDeliveryDetailsMutationVariables = Exact<{
  privateSessionId: string;
  deliveryDetails?: string | null | undefined;
  deliveryMethodId?: string | null | undefined;
}>;

export type PrivateSessionSaveDeliveryDetailsMutation = {
  privateSessionSaveDeliveryDetails: {
    stateBasketId: string | null;
    deliveryDetails: string | null;
    pickedDeliveryMethodId: string | null;
  } | null;
};

export const FilePricingFragmentDoc = gql`
  fragment FilePricing on FilePricing {
    isFull
    size
    filePricingId
    price {
      code
      price
    }
    stepPricingEnabled
    stepPricing {
      firstStep
      lastStepPrice {
        code
        price
      }
      mode
      isFirstStepFree
      steps {
        price {
          code
          price
        }
        step
      }
    }
    printsIncluded {
      count
      printFormatId
      printPaperId
    }
  }
`;
export const PrivateSessionGroupFragmentDoc = gql`
  fragment PrivateSessionGroup on PrivateSessionGroupForDisplay {
    name {
      language
      text
    }
    order
    privateSessionGroupId
    privateSessionId
    images {
      height
      photoGroupHasPhotoId
      photoId
      width
      photoGroupId
      originalName
    }
    customProductsConfig
    productsSort
    sellProducts
    excludedProducts
    customFilesPricing
    customPrintsPricing
    individualSellSettings
    deleted
    sellPrints
    sellFiles
    photoGroupId
    addToFirstPrintPrice
    addPriceToEveryFileInProduct
    useFilePricingToCalculatePriceToAddToEveryFileInProduct
    priceToAddToEveryFileInProduct {
      code
      price
    }
    skipAddToEveryFileInProductIfFileBought
    addEveryFileToBasketIfNotAlreadyBought
    priceToAddToEveryFileInProduct {
      code
      price
    }
    addPrintFileToBasketIfNotAlreadyBought
    priceToAddToFirstPrint {
      code
      price
    }
    skipAddToFirstPrintIfFileBought
    filePricing {
      ...FilePricing
    }
    printsPricing {
      printsPricingListForDisplayId
      list {
        price {
          code
          price
        }
        printFormatId
        printPaperId
        stepPricingEnabled
        stepPricing {
          firstStep
          isFirstStepFree
          lastStepPrice {
            code
            price
          }
          mode
          steps {
            price {
              code
              price
            }
            step
          }
        }
      }
    }
  }
  ${FilePricingFragmentDoc}
`;
export const LookBookPreviewDetailsFragmentDoc = gql`
  fragment LookBookPreviewDetails on WallDecorRenderPreviewConfig {
    images {
      crop {
        h
        w
        x
        y
      }
      photoGroupId
      photoId
      wallDecorPieceId
      isFlip
    }
    fileName
    wallDecorSceneId
    accessToken
    wallDecorRenderPreviewConfigId
    color
  }
`;
export const TriplexPreviewDetailsFragmentDoc = gql`
  fragment TriplexPreviewDetails on TriplexRenderPreviewConfig {
    images {
      crop {
        h
        w
        x
        y
      }
      photoGroupId
      photoId
      wallDecorPieceId
      isFlip
    }
    fileName
    accessToken
    triplexRenderPreviewConfigId
    value
  }
`;
export const TriplexProductFragmentDoc = gql`
  fragment TriplexProduct on Product {
    availableOnOccasion
    composedImages
    config
    configurationImages
    deliveryTime
    description {
      language
      text
    }
    hasWizard
    imagesRequired
    name
    price {
      code
      price
    }
    productId
    requiredImages {
      max
      min
    }
    showDeliveryTime
    status
    type
    sortOrder
    organizationId
  }
`;
export const PrivateSessionForDisplayDocument = gql`
  query PrivateSessionForDisplay(
    $privateSessionId: ID!
    $sessionId: ID!
    $deviceDetails: String
    $resolution: String
  ) {
    getPrivateSessionForDisplay(
      privateSessionId: $privateSessionId
      sessionId: $sessionId
      deviceDetails: $deviceDetails
      resolution: $resolution
    ) {
      privateSessionId
      organizationId
      squareLogo
      horizontalLogo
      name {
        language
        text
      }
      sellFiles
      sellPrints
      sellPackages
      sellProducts
      digitalOrderForcePhone
      freeThumbSize
      enableFreeThumb
      usePromoCodes
      autoSellEnabled
      autoSellConfig {
        organizationId
        verifyOrders
        verificationMode
      }
      salesMode
      created
      productsSort
      photoSuggestions {
        photoId
        comment {
          language
          text
        }
      }
      printsPricing {
        printsPricingListForDisplayId
        list {
          price {
            code
            price
          }
          printFormatId
          printPaperId
          stepPricingEnabled
          stepPricing {
            firstStep
            lastStepPrice {
              code
              price
            }
            isFirstStepFree
            mode
            steps {
              price {
                code
                price
              }
              step
            }
          }
        }
      }
      filePricing {
        ...FilePricing
      }
      availableProducts {
        availableOnOccasion
        composedImages
        config
        configurationImages
        deliveryTime
        description {
          language
          text
        }
        hasWizard
        imagesRequired
        name
        price {
          code
          price
        }
        productId
        requiredImages {
          max
          min
        }
        showDeliveryTime
        status
        type
        sortOrder
      }
      deliveryMethods {
        additionalFields {
          name
        }
        addressRequired
        currencyId
        deliveryMethodId
        freeFrom
        label
        mightBeFree
        phoneRequired
        pickupAddress
        pickupNote
        preOrderNote
        price
        status
        type
        countryId
        isAutoSell
      }
      packages {
        name
        icon
        productPackageId
        allowMultiple
        printAndFileConfig {
          printAndFileConfigId
          mode
          forcedImage {
            photoGroupId
            photoId
          }
          filesConfig {
            isFull
            count
            size
          }
          groups
          printAndFileConfigId
          printsCount {
            count
            printFormatId
            printPaperId
          }
        }
        price {
          code
          price
        }
        productConfig {
          config
          productId
          productInPackageId
          qty
          mode
          icon
          customName {
            language
            text
          }
        }
      }
      priceToAddToFirstPrint {
        code
        price
      }
      skipAddToFirstPrintIfFileBought
      addToFirstPrintPrice
      cover {
        file
        size {
          h
          w
        }
        x
        y
        coverSetupId
      }
      groups {
        ...PrivateSessionGroup
      }
      freePackageId
      addPriceToEveryFileInProduct
      priceToAddToEveryFileInProduct {
        code
        price
      }
      skipAddToEveryFileInProductIfFileBought
      addEveryFileToBasketIfNotAlreadyBought
      addPrintFileToBasketIfNotAlreadyBought
      useFilePricingToCalculatePriceToAddToEveryFileInProduct
      useFilePricingToCalculatePriceToAddToEveryFileInPrint
      retouchLevelsEnabled
      retouchLevels {
        retouchLevelId
        label {
          language
          text
        }
        price {
          code
          price
        }
      }
      excludedProducts
      showFileNames
      client {
        firstName
        lastName
        phone
        email
        privateSessionClientId
      }
      seenRecommendationComments
      photographerAvatar
      messages {
        context
        message {
          language
          text
        }
      }
      settlements {
        basicSessionPrice {
          alreadyPaid
          isSet
          price {
            price
            code
          }
        }
        requiredPrePayment {
          alreadyPaid
          isSet
          prePaidOption
          price {
            price
            code
          }
        }
      }
      lookBookEnabled
      lookBookConfig {
        sellWallDecor
        wallDecorConfig {
          rounding
          labId
          preConfig
          disablePersonalizationOnSinglePhoto
        }
        sellTambour
        tambourConfig {
          rounding
          labId
          preConfig
          disablePersonalizationOnSinglePhoto
        }
        sellTriplex
        triplexConfig {
          limitMaterials
          availableMaterials
          rounding
          labId
        }
        sellPrintFrames
        printFramesConfig {
          availableColors
          limitColors
          rounding
        }
        addEveryFileToBasketIfNotAlreadyBought
        addPriceToEveryFileInProduct
        priceToAddToEveryFileInProduct {
          code
          price
        }
        skipAddToEveryFileInProductIfFileBought
        useFilePricingToCalculatePriceToAddToEveryFileInProduct
      }
      skipFavoriteInFileMode
      visualPersonalization
      frame {
        productId
        config
        price {
          code
          price
        }
      }
      allowComments
      clientPermissionsConfig
    }
  }
  ${FilePricingFragmentDoc}
  ${PrivateSessionGroupFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class PrivateSessionForDisplayGQL extends Apollo.Query<
  PrivateSessionForDisplayQuery,
  PrivateSessionForDisplayQueryVariables
> {
  document = PrivateSessionForDisplayDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const GetPrivateSessionUserBasketDocument = gql`
  query getPrivateSessionUserBasket($privateSessionId: ID!) {
    getPrivateSessionUserBasket(privateSessionId: $privateSessionId) {
      favorites
      stateBasketId
      files {
        filePricingId
        isFull
        photoId
        retouchLevelId
        size
        timeAddedToShoppingCart
        togetherWithPrint
        togetherWithProduct
      }
      printFramesInBasket {
        printFrameId
        photoId
        count
        price {
          price
          code
        }
        printFormatId
        ratio
        value
      }
      prints {
        photoId
        count
        printFormatId
        printPaperId
        printId
        timeAddedToShoppingCart
        togetherWithFile
      }
      printFramesInBasket {
        printFrameId
        printFormatId
        photoId
        value
        ratio
        count
        price {
          code
          price
        }
      }
      products {
        timeAddedToShoppingCart
        configuration
        finished {
          allImages
          allOptions
        }
        nameClientProduct
        photoIdList
        productId
        quantity
        redBackground
        selectedProductId
      }
      lookBookProductsInBasket {
        config
        lookBookProductId
        countPhotos {
          min
          max
        }
        redBackground
        finished
        lookBookProductConfigId
        productsInPlay
        name {
          text
          language
        }
        firstAddedFile
        hasPersonalization
        nameClientProduct
        personalizationConfig
        photoIdList
        quantity
        thumb
        valueMap
        accessToken
        price {
          price
          code
        }
        timeAddedToShoppingCart
        imageMap {
          isFlip
          crop {
            y
            x
            w
            h
          }
          photoGroupId
          photoId
          wallDecorPieceId
        }
      }
      lookBookWallDecorPreviewRender {
        ...LookBookPreviewDetails
      }
      lookBookTambourPreviewRender {
        ...LookBookPreviewDetails
      }
      triplexPreviewRender {
        ...TriplexPreviewDetails
      }
      photoComments {
        position {
          x
          y
        }
        messages {
          posted
          comment
          author
        }
        state
        photoCommentId
        photoId
      }
      pickedDeliveryMethodId
      deliveryDetails
    }
  }
  ${LookBookPreviewDetailsFragmentDoc}
  ${TriplexPreviewDetailsFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class GetPrivateSessionUserBasketGQL extends Apollo.Query<
  GetPrivateSessionUserBasketQuery,
  GetPrivateSessionUserBasketQueryVariables
> {
  document = GetPrivateSessionUserBasketDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const GetPrivateSessionUserOldBasketDocument = gql`
  query getPrivateSessionUserOldBasket($privateSessionId: ID!) {
    getPrivateSessionUserOldBasket(privateSessionId: $privateSessionId) {
      files {
        filePricingId
        photoId
        togetherWithPrint
        togetherWithProduct
      }
      prints {
        photoId
        count
        printFormatId
        printPaperId
        togetherWithFile
      }
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class GetPrivateSessionUserOldBasketGQL extends Apollo.Query<
  GetPrivateSessionUserOldBasketQuery,
  GetPrivateSessionUserOldBasketQueryVariables
> {
  document = GetPrivateSessionUserOldBasketDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const PlaceOrderDocument = gql`
  mutation placeOrder($orderDetails: NewShoppingCartOrderInput) {
    placeShoppingCartOrder(newOrderDetails: $orderDetails) {
      orderId
      orderNumber
      placed
      hash
      sourceInactive
      authToken
      status {
        done
        label {
          language
          text
        }
        statusId
        order
        done
      }
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class PlaceOrderGQL extends Apollo.Mutation<
  PlaceOrderMutation,
  PlaceOrderMutationVariables
> {
  document = PlaceOrderDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const ChangeFavPhotoStatusDocument = gql`
  mutation changeFavPhotoStatus(
    $privateSessionId: ID!
    $isLiked: Boolean!
    $photoId: ID!
    $sessionId: ID!
  ) {
    privateSessionChangeFavPhotoStatus(
      privateSessionId: $privateSessionId
      isLiked: $isLiked
      photoId: $photoId
      sessionId: $sessionId
    ) {
      status
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class ChangeFavPhotoStatusGQL extends Apollo.Mutation<
  ChangeFavPhotoStatusMutation,
  ChangeFavPhotoStatusMutationVariables
> {
  document = ChangeFavPhotoStatusDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const PrivateSessionPhotoAddedToFilesDocument = gql`
  mutation privateSessionPhotoAddedToFiles(
    $photoIds: [ID]!
    $privateSessionId: ID!
    $isFull: Boolean!
    $size: Int!
    $sessionId: ID!
    $filePricingId: ID!
    $retouchLevel: String!
    $retouchLevelId: ID!
    $state: [FileState]!
  ) {
    privateSessionPhotosAddedToFiles(
      photoIds: $photoIds
      sessionId: $sessionId
      privateSessionId: $privateSessionId
      size: $size
      isFull: $isFull
      filePricingId: $filePricingId
      retouchLevel: $retouchLevel
      retouchLevelId: $retouchLevelId
      state: $state
    ) {
      status
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class PrivateSessionPhotoAddedToFilesGQL extends Apollo.Mutation<
  PrivateSessionPhotoAddedToFilesMutation,
  PrivateSessionPhotoAddedToFilesMutationVariables
> {
  document = PrivateSessionPhotoAddedToFilesDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const PrivateSessionPhotoRemovedFromFilesDocument = gql`
  mutation privateSessionPhotoRemovedFromFiles(
    $privateSessionId: ID!
    $sessionId: ID!
    $photoIds: [ID]!
  ) {
    privateSessionPhotosRemovedFromFiles(
      privateSessionId: $privateSessionId
      sessionId: $sessionId
      photoIds: $photoIds
    ) {
      status
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class PrivateSessionPhotoRemovedFromFilesGQL extends Apollo.Mutation<
  PrivateSessionPhotoRemovedFromFilesMutation,
  PrivateSessionPhotoRemovedFromFilesMutationVariables
> {
  document = PrivateSessionPhotoRemovedFromFilesDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const PrivateSessionPhotosRemovedFromPrintsDocument = gql`
  mutation privateSessionPhotosRemovedFromPrints(
    $printIds: [ID]!
    $privateSessionId: ID!
    $sessionId: ID!
  ) {
    privateSessionPhotosRemovedFromPrints(
      printIds: $printIds
      privateSessionId: $privateSessionId
      sessionId: $sessionId
    ) {
      status
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class PrivateSessionPhotosRemovedFromPrintsGQL extends Apollo.Mutation<
  PrivateSessionPhotosRemovedFromPrintsMutation,
  PrivateSessionPhotosRemovedFromPrintsMutationVariables
> {
  document = PrivateSessionPhotosRemovedFromPrintsDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const PrivateSessionPhotosChangedSizeDocument = gql`
  mutation privateSessionPhotosChangedSize(
    $sessionId: ID!
    $privateSessionId: ID!
    $photoIds: [ID]!
    $isFull: Boolean!
    $size: Int!
    $filePricingId: ID!
  ) {
    privateSessionPhotosChangedSize(
      sessionId: $sessionId
      privateSessionId: $privateSessionId
      photoIds: $photoIds
      isFull: $isFull
      size: $size
      filePricingId: $filePricingId
    ) {
      status
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class PrivateSessionPhotosChangedSizeGQL extends Apollo.Mutation<
  PrivateSessionPhotosChangedSizeMutation,
  PrivateSessionPhotosChangedSizeMutationVariables
> {
  document = PrivateSessionPhotosChangedSizeDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const PrivateSessionPhotosAddedToPrintsDocument = gql`
  mutation privateSessionPhotosAddedToPrints(
    $photoIds: [ID]!
    $privateSessionId: ID!
    $sessionId: ID!
    $printFormatId: ID!
    $printPaperId: ID!
    $state: [PrintState]!
    $togetherWithFile: Boolean
    $count: Int!
  ) {
    privateSessionPhotosAddedToPrints(
      photoIds: $photoIds
      privateSessionId: $privateSessionId
      printFormatId: $printFormatId
      printPaperId: $printPaperId
      sessionId: $sessionId
      state: $state
      togetherWithFile: $togetherWithFile
      count: $count
    ) {
      status
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class PrivateSessionPhotosAddedToPrintsGQL extends Apollo.Mutation<
  PrivateSessionPhotosAddedToPrintsMutation,
  PrivateSessionPhotosAddedToPrintsMutationVariables
> {
  document = PrivateSessionPhotosAddedToPrintsDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const PrivateSessionMarkRecommendationCommentAsSeenDocument = gql`
  mutation privateSessionMarkRecommendationCommentAsSeen(
    $privateSessionId: ID!
    $photoId: ID!
    $sessionId: ID!
    $alreadySeen: Boolean!
    $content: [CustomLabelInput]!
  ) {
    privateSessionMarkRecommendationCommentAsSeen(
      photoId: $photoId
      sessionId: $sessionId
      privateSessionId: $privateSessionId
      alreadySeen: $alreadySeen
      content: $content
    ) {
      status
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class PrivateSessionMarkRecommendationCommentAsSeenGQL extends Apollo.Mutation<
  PrivateSessionMarkRecommendationCommentAsSeenMutation,
  PrivateSessionMarkRecommendationCommentAsSeenMutationVariables
> {
  document = PrivateSessionMarkRecommendationCommentAsSeenDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const PrivateSessionPhotosChangedRetouchLevelDocument = gql`
  mutation privateSessionPhotosChangedRetouchLevel(
    $photoIds: [ID]!
    $privateSessionId: ID!
    $retouchLevel: String!
    $retouchLevelId: ID!
    $sessionId: ID!
  ) {
    privateSessionPhotosChangedRetouchLevel(
      photoIds: $photoIds
      privateSessionId: $privateSessionId
      retouchLevel: $retouchLevel
      retouchLevelId: $retouchLevelId
      sessionId: $sessionId
    ) {
      status
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class PrivateSessionPhotosChangedRetouchLevelGQL extends Apollo.Mutation<
  PrivateSessionPhotosChangedRetouchLevelMutation,
  PrivateSessionPhotosChangedRetouchLevelMutationVariables
> {
  document = PrivateSessionPhotosChangedRetouchLevelDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const PrivateSessionAddedProductToBasketDocument = gql`
  mutation privateSessionAddedProductToBasket(
    $privateSessionId: ID!
    $sessionId: ID!
    $configuration: String!
    $finished: FinishedProductMutation!
    $nameClientProduct: String!
    $photoIdList: [String]!
    $productId: ID!
    $quantity: Int!
    $redBackground: Boolean!
    $firstAddedFile: Boolean!
    $selectedProductId: ID!
  ) {
    privateSessionAddedProductToBasket(
      privateSessionId: $privateSessionId
      sessionId: $sessionId
      configuration: $configuration
      finished: $finished
      nameClientProduct: $nameClientProduct
      photoIdList: $photoIdList
      productId: $productId
      quantity: $quantity
      redBackground: $redBackground
      firstAddedFile: $firstAddedFile
      selectedProductId: $selectedProductId
    ) {
      status
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class PrivateSessionAddedProductToBasketGQL extends Apollo.Mutation<
  PrivateSessionAddedProductToBasketMutation,
  PrivateSessionAddedProductToBasketMutationVariables
> {
  document = PrivateSessionAddedProductToBasketDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const PrivateSessionChangeQuantityProductDocument = gql`
  mutation privateSessionChangeQuantityProduct(
    $privateSessionId: ID!
    $sessionId: ID!
    $selectedProductId: ID
    $quantity: Int
  ) {
    privateSessionChangeQuantityProduct(
      privateSessionId: $privateSessionId
      sessionId: $sessionId
      selectedProductId: $selectedProductId
      quantity: $quantity
    ) {
      status
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class PrivateSessionChangeQuantityProductGQL extends Apollo.Mutation<
  PrivateSessionChangeQuantityProductMutation,
  PrivateSessionChangeQuantityProductMutationVariables
> {
  document = PrivateSessionChangeQuantityProductDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const PrivateSessionChangePhotosInProductDocument = gql`
  mutation privateSessionChangePhotosInProduct(
    $privateSessionId: ID!
    $sessionId: ID!
    $selectedProductId: ID
    $addedPhotoIdList: [String]
    $removedPhotoIdList: [String]
    $finishedAllImages: Boolean
    $redBackground: Boolean
  ) {
    privateSessionChangePhotosInProduct(
      privateSessionId: $privateSessionId
      sessionId: $sessionId
      selectedProductId: $selectedProductId
      addedPhotoIdList: $addedPhotoIdList
      removedPhotoIdList: $removedPhotoIdList
      finishedAllImages: $finishedAllImages
      redBackground: $redBackground
    ) {
      status
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class PrivateSessionChangePhotosInProductGQL extends Apollo.Mutation<
  PrivateSessionChangePhotosInProductMutation,
  PrivateSessionChangePhotosInProductMutationVariables
> {
  document = PrivateSessionChangePhotosInProductDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const PrivateSessionChangeConfigInProductDocument = gql`
  mutation privateSessionChangeConfigInProduct(
    $privateSessionId: ID!
    $sessionId: ID!
    $selectedProductId: ID
    $configuration: String
    $finishedAllOptions: Boolean
    $redBackground: Boolean
  ) {
    privateSessionChangeConfigInProduct(
      privateSessionId: $privateSessionId
      sessionId: $sessionId
      selectedProductId: $selectedProductId
      configuration: $configuration
      finishedAllOptions: $finishedAllOptions
      redBackground: $redBackground
    ) {
      status
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class PrivateSessionChangeConfigInProductGQL extends Apollo.Mutation<
  PrivateSessionChangeConfigInProductMutation,
  PrivateSessionChangeConfigInProductMutationVariables
> {
  document = PrivateSessionChangeConfigInProductDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const PrivateSessionRemovedProductFromBasketDocument = gql`
  mutation privateSessionRemovedProductFromBasket(
    $privateSessionId: ID!
    $sessionId: ID!
    $selectedProductId: ID
  ) {
    privateSessionRemovedProductFromBasket(
      privateSessionId: $privateSessionId
      sessionId: $sessionId
      selectedProductId: $selectedProductId
    ) {
      status
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class PrivateSessionRemovedProductFromBasketGQL extends Apollo.Mutation<
  PrivateSessionRemovedProductFromBasketMutation,
  PrivateSessionRemovedProductFromBasketMutationVariables
> {
  document = PrivateSessionRemovedProductFromBasketDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const WatchForPrivateSessionActionsDocument = gql`
  subscription watchForPrivateSessionActions(
    $privateSessionId: ID!
    $sessionId: ID!
  ) {
    watchForPrivateSessionActions(
      privateSessionId: $privateSessionId
      sessionId: $sessionId
    ) {
      sessionId
      action
      payload
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class WatchForPrivateSessionActionsGQL extends Apollo.Subscription<
  WatchForPrivateSessionActionsSubscription,
  WatchForPrivateSessionActionsSubscriptionVariables
> {
  document = WatchForPrivateSessionActionsDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const SharePrivateSessionActionDocument = gql`
  mutation sharePrivateSessionAction(
    $action: ID!
    $payload: String!
    $sessionId: ID!
    $privateSessionId: ID!
  ) {
    sharePrivateSessionAction(
      payload: $payload
      action: $action
      sessionId: $sessionId
      privateSessionId: $privateSessionId
    ) {
      status
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class SharePrivateSessionActionGQL extends Apollo.Mutation<
  SharePrivateSessionActionMutation,
  SharePrivateSessionActionMutationVariables
> {
  document = SharePrivateSessionActionDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const GetLookBookTriplexDetailsForPrivateSessionDocument = gql`
  query getLookBookTriplexDetailsForPrivateSession($privateSessionId: ID!) {
    getTriplexLookBookConfigForPrivateSession(
      privateSessionId: $privateSessionId
    ) {
      labsInPlay
      labProducts {
        ...TriplexProduct
      }
      zalamoStandaloneTriplex {
        ...TriplexProduct
      }
    }
  }
  ${TriplexProductFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class GetLookBookTriplexDetailsForPrivateSessionGQL extends Apollo.Query<
  GetLookBookTriplexDetailsForPrivateSessionQuery,
  GetLookBookTriplexDetailsForPrivateSessionQueryVariables
> {
  document = GetLookBookTriplexDetailsForPrivateSessionDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const UpdateWallDecorPreviewUpdateDocument = gql`
  mutation updateWallDecorPreviewUpdate(
    $privateSessionId: ID!
    $update: WallDecorRenderPreviewConfigInput
  ) {
    updatePrivateSessionWallDecorPreview(
      privateSessionId: $privateSessionId
      update: $update
    ) {
      ...LookBookPreviewDetails
    }
  }
  ${LookBookPreviewDetailsFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class UpdateWallDecorPreviewUpdateGQL extends Apollo.Mutation<
  UpdateWallDecorPreviewUpdateMutation,
  UpdateWallDecorPreviewUpdateMutationVariables
> {
  document = UpdateWallDecorPreviewUpdateDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const UpdateTambourPreviewUpdateDocument = gql`
  mutation updateTambourPreviewUpdate(
    $privateSessionId: ID!
    $update: WallDecorRenderPreviewConfigInput
  ) {
    updatePrivateSessionTambourPreview(
      privateSessionId: $privateSessionId
      update: $update
    ) {
      ...LookBookPreviewDetails
    }
  }
  ${LookBookPreviewDetailsFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class UpdateTambourPreviewUpdateGQL extends Apollo.Mutation<
  UpdateTambourPreviewUpdateMutation,
  UpdateTambourPreviewUpdateMutationVariables
> {
  document = UpdateTambourPreviewUpdateDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const UpdateTriplexPreviewUpdateDocument = gql`
  mutation updateTriplexPreviewUpdate(
    $privateSessionId: ID!
    $update: TriplexRenderPreviewConfigInput
  ) {
    updatePrivateSessionTriplexPreview(
      privateSessionId: $privateSessionId
      update: $update
    ) {
      ...TriplexPreviewDetails
    }
  }
  ${TriplexPreviewDetailsFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class UpdateTriplexPreviewUpdateGQL extends Apollo.Mutation<
  UpdateTriplexPreviewUpdateMutation,
  UpdateTriplexPreviewUpdateMutationVariables
> {
  document = UpdateTriplexPreviewUpdateDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const PrivateSessionLookBookProductAddedToBasketDocument = gql`
  mutation privateSessionLookBookProductAddedToBasket(
    $privateSessionId: ID!
    $product: LookBookInBasketInput
  ) {
    privateSessionLookBookProductAddedToBasket(
      privateSessionId: $privateSessionId
      product: $product
    ) {
      status
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class PrivateSessionLookBookProductAddedToBasketGQL extends Apollo.Mutation<
  PrivateSessionLookBookProductAddedToBasketMutation,
  PrivateSessionLookBookProductAddedToBasketMutationVariables
> {
  document = PrivateSessionLookBookProductAddedToBasketDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const PrivateSessionLookBookProductDeletedDocument = gql`
  mutation privateSessionLookBookProductDeleted(
    $privateSessionId: ID!
    $lookBookProductConfigId: ID!
  ) {
    privateSessionLookBookProductDeleted(
      privateSessionId: $privateSessionId
      lookBookProductConfigId: $lookBookProductConfigId
    ) {
      status
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class PrivateSessionLookBookProductDeletedGQL extends Apollo.Mutation<
  PrivateSessionLookBookProductDeletedMutation,
  PrivateSessionLookBookProductDeletedMutationVariables
> {
  document = PrivateSessionLookBookProductDeletedDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const PrivateSessionLookBookProductCountChangedDocument = gql`
  mutation privateSessionLookBookProductCountChanged(
    $privateSessionId: ID!
    $lookBookProductConfigId: ID!
    $quantity: Int!
  ) {
    privateSessionLookBookProductCountChanged(
      privateSessionId: $privateSessionId
      lookBookProductConfigId: $lookBookProductConfigId
      count: $quantity
    ) {
      status
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class PrivateSessionLookBookProductCountChangedGQL extends Apollo.Mutation<
  PrivateSessionLookBookProductCountChangedMutation,
  PrivateSessionLookBookProductCountChangedMutationVariables
> {
  document = PrivateSessionLookBookProductCountChangedDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const PrivateSessionLookBookProductChangedDocument = gql`
  mutation privateSessionLookBookProductChanged(
    $lookBookProductConfigId: ID!
    $privateSessionId: ID!
    $update: LookBookInBasketInput!
  ) {
    privateSessionLookBookProductChanged(
      lookBookProductConfigId: $lookBookProductConfigId
      privateSessionId: $privateSessionId
      update: $update
    ) {
      status
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class PrivateSessionLookBookProductChangedGQL extends Apollo.Mutation<
  PrivateSessionLookBookProductChangedMutation,
  PrivateSessionLookBookProductChangedMutationVariables
> {
  document = PrivateSessionLookBookProductChangedDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const AddPhotoCommentToPrivateSessionPhotoDocument = gql`
  mutation addPhotoCommentToPrivateSessionPhoto(
    $message: String!
    $photoCommentId: ID!
    $photoId: ID!
    $privateSessionId: ID!
    $x: Float!
    $y: Float!
  ) {
    addPhotoCommentToPrivateSessionPhoto(
      message: $message
      photoCommentId: $photoCommentId
      photoId: $photoId
      privateSessionId: $privateSessionId
      x: $x
      y: $y
    ) {
      photoCommentId
      state
      messages {
        comment
        author
        posted
      }
      photoId
      position {
        y
        x
      }
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class AddPhotoCommentToPrivateSessionPhotoGQL extends Apollo.Mutation<
  AddPhotoCommentToPrivateSessionPhotoMutation,
  AddPhotoCommentToPrivateSessionPhotoMutationVariables
> {
  document = AddPhotoCommentToPrivateSessionPhotoDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const UpdatePhotoCommentToPrivateSessionPhotoDocument = gql`
  mutation updatePhotoCommentToPrivateSessionPhoto(
    $message: String!
    $photoCommentId: ID!
    $privateSessionId: ID!
  ) {
    updatePhotoCommentToPrivateSessionPhoto(
      message: $message
      photoCommentId: $photoCommentId
      privateSessionId: $privateSessionId
    ) {
      photoCommentId
      state
      messages {
        comment
        author
        posted
      }
      photoId
      position {
        y
        x
      }
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class UpdatePhotoCommentToPrivateSessionPhotoGQL extends Apollo.Mutation<
  UpdatePhotoCommentToPrivateSessionPhotoMutation,
  UpdatePhotoCommentToPrivateSessionPhotoMutationVariables
> {
  document = UpdatePhotoCommentToPrivateSessionPhotoDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const RemovePhotoCommentToPrivateSessionPhotoDocument = gql`
  mutation removePhotoCommentToPrivateSessionPhoto(
    $photoCommentId: ID!
    $privateSessionId: ID!
  ) {
    removePhotoCommentToPrivateSessionPhoto(
      photoCommentId: $photoCommentId
      privateSessionId: $privateSessionId
    ) {
      status
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class RemovePhotoCommentToPrivateSessionPhotoGQL extends Apollo.Mutation<
  RemovePhotoCommentToPrivateSessionPhotoMutation,
  RemovePhotoCommentToPrivateSessionPhotoMutationVariables
> {
  document = RemovePhotoCommentToPrivateSessionPhotoDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const PrivateSessionPrintFrameAddedToBasketDocument = gql`
  mutation privateSessionPrintFrameAddedToBasket(
    $privateSessionId: ID!
    $product: PrintFrameInBasketInput
  ) {
    privateSessionPrintFrameAddedToBasket(
      privateSessionId: $privateSessionId
      product: $product
    ) {
      status
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class PrivateSessionPrintFrameAddedToBasketGQL extends Apollo.Mutation<
  PrivateSessionPrintFrameAddedToBasketMutation,
  PrivateSessionPrintFrameAddedToBasketMutationVariables
> {
  document = PrivateSessionPrintFrameAddedToBasketDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const PrivateSessionPrintFrameDeletedDocument = gql`
  mutation privateSessionPrintFrameDeleted(
    $privateSessionId: ID!
    $printFrameId: ID!
  ) {
    privateSessionPrintFrameDeleted(
      privateSessionId: $privateSessionId
      printFrameId: $printFrameId
    ) {
      status
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class PrivateSessionPrintFrameDeletedGQL extends Apollo.Mutation<
  PrivateSessionPrintFrameDeletedMutation,
  PrivateSessionPrintFrameDeletedMutationVariables
> {
  document = PrivateSessionPrintFrameDeletedDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const PrivateSessionPrintFrameCountChangedDocument = gql`
  mutation privateSessionPrintFrameCountChanged(
    $privateSessionId: ID!
    $printFrameId: ID!
    $quantity: Int!
  ) {
    privateSessionPrintFrameCountChanged(
      privateSessionId: $privateSessionId
      printFrameId: $printFrameId
      count: $quantity
    ) {
      status
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class PrivateSessionPrintFrameCountChangedGQL extends Apollo.Mutation<
  PrivateSessionPrintFrameCountChangedMutation,
  PrivateSessionPrintFrameCountChangedMutationVariables
> {
  document = PrivateSessionPrintFrameCountChangedDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const PrivateSessionPrintFrameChangedDocument = gql`
  mutation privateSessionPrintFrameChanged(
    $privateSessionId: ID!
    $printFrameId: ID!
    $update: PrintFrameInBasketInput!
  ) {
    privateSessionPrintFrameChanged(
      privateSessionId: $privateSessionId
      printFrameId: $printFrameId
      update: $update
    ) {
      status
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class PrivateSessionPrintFrameChangedGQL extends Apollo.Mutation<
  PrivateSessionPrintFrameChangedMutation,
  PrivateSessionPrintFrameChangedMutationVariables
> {
  document = PrivateSessionPrintFrameChangedDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const PrivateSessionSaveDeliveryDetailsDocument = gql`
  mutation privateSessionSaveDeliveryDetails(
    $privateSessionId: ID!
    $deliveryDetails: String
    $deliveryMethodId: ID
  ) {
    privateSessionSaveDeliveryDetails(
      privateSessionId: $privateSessionId
      deliveryDetails: $deliveryDetails
      pickedDeliveryMethodId: $deliveryMethodId
    ) {
      stateBasketId
      deliveryDetails
      pickedDeliveryMethodId
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class PrivateSessionSaveDeliveryDetailsGQL extends Apollo.Mutation<
  PrivateSessionSaveDeliveryDetailsMutation,
  PrivateSessionSaveDeliveryDetailsMutationVariables
> {
  document = PrivateSessionSaveDeliveryDetailsDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
